module.exports = __webpack_public_path__ + "img/misosha_shangxiang_msbg_11_23_08_21.38ccca7d.png";